var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 p-2"},[_c('footer',{staticClass:"container-fluid small text-center"},[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")]),_c('span',{staticClass:"mx-1 text-separator"}),_c('router-link',{attrs:{"to":"/terms-of-use"}},[_vm._v("Terms of Use")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }